import GlobalRequest from './global-request';
import { formatRequestDate } from '@/helpers/date-formatter';

const URL = 'v2/admin/users';
const MFA_URL = 'v2/admin/otp';

export default class UserApi {
    static async createUser(body) {
        return await GlobalRequest.postRequest(URL, body);
    }

    static async getAllUsers(company_id, params) {
        if (!params || Object.keys(params)?.length <= 0) {
            params = this.setNullParams();
        }
        return await GlobalRequest.getRequest(URL, {
            params: {
                ...params,
                company_id,
                page_size: params.page_size,
                page: params.page + 1,
                reference: params?.reference,
                name: params?.name,
                surname: params?.surname,
                age_start: params?.age_start,
                age_end: params?.age_end,
                dob_start: params?.dob_start ? formatRequestDate(params?.dob_start) : null,
                dob_end: params?.dob_end ? formatRequestDate(params?.dob_end) : null,
                email: params?.email,
                sex: params?.sex,
            },
        });
    }
    static async getUserById(userId, company_id) {
        return await GlobalRequest.getRequest(URL + '/' + userId, {
            params: {
                company_id,
            },
        });
    }
    static async checkUserMfa(userId, company_id) {
        return await GlobalRequest.getRequest(MFA_URL + '/' + userId, {
            params: {
                company_id,
            },
        });
    }
    static async updateUserDetails(userId, body) {
        return await GlobalRequest.patchRequest(URL + '/' + userId, body);
    }
    static setNullParams() {
        return {
            rows: null,
            page: null,
        };
    }
}
